
export const STATUS_APPROVED = "Approved";
export const STATUS_REJECTED = "Rejected";
export const ACTION_APPROVE = "Approve";
export const ACTION_REJECT = "Reject";

// For backend API (admin status update)
export const API_STATUS_APPROVE = "APPROVED";
export const API_STATUS_REJECT = "REJECTED";

// For UI/local state (admin status)
export const UI_STATUS_APPROVED = "APPROVED";
export const UI_STATUS_REJECTED = "REJECTED";
